import type { AiChatState } from "@intelligems/ig-types";

export const createInitialAiChatState = (): AiChatState => ({
  sessionId: "",
  workflowId: "",
  status: "waiting_for_input",
  turns: [],
  metadata: {},
  turnLookups: {},
  nodeLookups: {},
  messageLookups: {},
  nextAction: undefined,
  workflowStartTime: undefined,
});

export const initialAiChatState: AiChatState = createInitialAiChatState();
